import './UpdateViewButton.scss';
import React from 'react';
import { SaveFilled } from '@ant-design/icons';
import { useAction } from '@hooks';
import { coreActions } from '@sonar-software/sonar-core';
export const UpdateViewButton = ({ queryParams, view }) => {
    const update = useAction(coreActions.requestPatchCoreDataDictionaryViews);
    const hasDifference = view.id === queryParams.lastViewId &&
        (view.columns !== queryParams.columns ||
            view.filter !== queryParams.filters ||
            view.ordering !== queryParams.ordering);
    if (!hasDifference) {
        return null;
    }
    return (React.createElement(SaveFilled, { className: 'view-save-changes-icon', onClick: (e) => {
            var _a, _b, _c;
            e.stopPropagation();
            update({
                columns: (_a = queryParams.columns) !== null && _a !== void 0 ? _a : '',
                filter: (_b = queryParams.filters) !== null && _b !== void 0 ? _b : '',
                ordering: (_c = queryParams.ordering) !== null && _c !== void 0 ? _c : '',
                viewId: view.id
            });
        } }));
};
